import React, {useContext} from "react";
import {BoShowContext} from "../context/bo-show-context.jsx";

const BoShowRectification = () => {
    const {boData} = useContext(BoShowContext);
    const rectification = boData?.rectification;

    if (!rectification) return null;

    return (
        <article className={"space-y-4"}>
            <h2 className={"resume-title"}>RETIFICAÇÃO</h2>

            <p className={"info whitespace-pre-wrap text-justify"}>{rectification?.value ?? ""}</p>

            <p>
                Retificado por: <span className={"info"}>{rectification?.userName ?? ""}</span> em <span className={"info"}>{rectification?.date ?? ""}</span>
            </p>
        </article>
    );
};

export default BoShowRectification;
